const parseJSONstring = (str: string) => {
  const cleanedStr = str.replace(/\\“/g, '"');
  try {
    const parsedValue = JSON.parse(cleanedStr);
    return parsedValue;
  } catch {
    return str;
  }
};

export default parseJSONstring;
